import { render, staticRenderFns } from "./invoices-summary.vue?vue&type=template&id=4825f2e0&"
import script from "./invoices-summary.vue?vue&type=script&lang=js&"
export * from "./invoices-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports